import type { ServerConfig } from '@/@types';

export const serverConfig: ServerConfig = {
  subject: '测试环境2',
  environment: 'test2',
  apiSrc: 'https://saas-api.pdaia.cn',
  questionarySrc: 'https://que-design-lite.pdaia.cn',
};
